<template>
  <div>
    <v-btn icon @click="dialog = true">
      <v-icon>mdi-pencil</v-icon>
    </v-btn>

    <SysDialogFullScreen
      v-model="dialog"
      titulo="Editar categoria de compra"
      @click:hidden-dialog="resetValores()"
    >
      <template #titulo-parte-direita>
        <DialogEditarCategoria
          :nome_categoria_prop="categoria.nome_categoria"
          @atualizar-categoria-materia-prima="save($event)"
        />
      </template>

      <v-breadcrumbs class="systock-breadcrump" dark>
        <v-breadcrumbs-item> Configuração da Categoria </v-breadcrumbs-item>
      </v-breadcrumbs>

      <div class="row px-1 ma-0">
        <div class="col-4">
          <sys-data-table
            v-model="itens_selecionados.produtos_mp"
            :height="alturaDaJanela - 160"
            :headers="headers"
            :items="FILTRO_CUSTOMIZADO_PRODUTOS_MP"
            :item-height="50"
            :items-per-page="-1"
            item-key="id_produto"
            fixed-header
            show-select
            hide-default-footer
            class="elevation-1"
          >
            <template #top>
              <v-text-field
                class="mx-4"
                v-model="search.produtos_mp"
                outlined
                dense
                append-icon="mdi-magnify"
                label="Pesquisar Produtos MP"
                single-line
                hide-details
              ></v-text-field>
            </template>
          </sys-data-table>
        </div>

        <div class="col-4">
          <sys-data-table
            v-model="itens_selecionados.produtos_pa"
            :height="alturaDaJanela - 160"
            :headers="headers"
            :items="FILTRO_CUSTOMIZADO_PRODUTOS_PA"
            :item-height="50"
            :items-per-page="-1"
            item-key="id_produto"
            fixed-header
            show-select
            hide-default-footer
            class="elevation-1"
          >
            <template #top>
              <v-text-field
                class="mx-4"
                v-model="search.produtos_pa"
                outlined
                dense
                append-icon="mdi-magnify"
                label="Pesquisar Produtos PA"
                single-line
                hide-details
              ></v-text-field>
            </template>
          </sys-data-table>
        </div>

        <div class="col-4">
          <sys-data-table
            v-model="itens_selecionados.produtos_mp_relacionado"
            :height="alturaDaJanela - 160"
            :headers="headers"
            :items="FILTRO_CUSTOMIZADO_PRODUTOS_MP_RELACIONADO"
            :item-height="50"
            :items-per-page="-1"
            item-key="id_produto"
            fixed-header
            show-select
            hide-default-footer
            class="elevation-1"
          >
            <template #top>
              <v-text-field
                class="mx-4"
                v-model="search.produtos_mp_relacionado"
                outlined
                dense
                append-icon="mdi-magnify"
                label="Pesquisar Produtos MP Relacionados"
                single-line
                hide-details
              ></v-text-field>
            </template>
          </sys-data-table>
        </div>
      </div>
    </SysDialogFullScreen>
  </div>
</template>

<script>
import DialogEditarCategoria from "./DialogEditarCategoria.vue";
import Responsividade from "@/helpers/ResponsiveHeight";
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import SysDialogFullScreen from "@/components/padraoDeLayout/SysDialogFullScreen.vue";
import SysDataTable from "@/components/utils/dataTable/sysDataTable/Index.vue";
import CategoriaMateriaPrimaAPI from "@/api/categoriaCompraMateriaPrima";
import { getProdutosCategoria, updateRelacionamentosMPPA } from "@/api/categoriaCompraMateriaPrima";

export default {
  mixins: [Responsividade],
  components: {
    SysDialogFullScreen,
    SysDataTable,
    SysDialog,
    DialogEditarCategoria
  },
  props: {
    categoria: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      search: {
        produtos_mp: "",
        produtos_pa: "",
        produtos_mp_relacionado: "",
      },
      itens_selecionados: {
        produtos_mp: [],
        produtos_pa: [],
        produtos_mp_relacionado: [],
      },
      headers: [
        {
          text: "ID Produto",
          value: "id_produto",
          style: {
            minWidth: "50px",
            maxWidth: "50px",
          },
        },
        {
          text: "Descricao Produto",
          value: "descricao_produto",
        },
      ],
      desserts: {
        produtos_mp: [],
        produtos_pa: [],
        produtos_mp_relacionado: [],
      },
    };
  },
  computed: {
    FILTRO_CUSTOMIZADO_PRODUTOS_MP() {
      const givenArray = this.desserts.produtos_mp;
      const includeValues = this.search.produtos_mp.toLowerCase().split(" ");

      let new_dessert = givenArray.filter((dd) => {
        let value = 0;

        includeValues.forEach(function (word) {
          if (Object.values(dd).join('').toLowerCase().includes(word)) {
            value = value + 1;
          }
        });

        return value === includeValues.length;
      });

      return new_dessert.length > 0 || includeValues.length > 0
        ? new_dessert
        : this.desserts_esquerda;
    },

    FILTRO_CUSTOMIZADO_PRODUTOS_PA() {
      const givenArray = this.desserts.produtos_pa;
      const includeValues = this.search.produtos_pa.toLowerCase().split(" ");

      let new_dessert = givenArray.filter((dd) => {
        let value = 0;

        includeValues.forEach(function (word) {
          if (Object.values(dd).join('').toLowerCase().includes(word)) {
            value = value + 1;
          }
        });

        return value === includeValues.length;
      });

      return new_dessert.length > 0 || includeValues.length > 0
        ? new_dessert
        : this.desserts_esquerda;
    },

    FILTRO_CUSTOMIZADO_PRODUTOS_MP_RELACIONADO() {
      const givenArray = this.desserts.produtos_mp_relacionado;
      const includeValues = this.search.produtos_mp_relacionado
        .toLowerCase()
        .split(" ");

      let new_dessert = givenArray.filter((dd) => {
        let value = 0;

        includeValues.forEach(function (word) {
          if (Object.values(dd).join('').toLowerCase().includes(word)) {
            value = value + 1;
          }
        });

        return value === includeValues.length;
      });

      const item_produto_mp = this.itens_selecionados.produtos_mp;

      let desserts_atualizado = new_dessert.filter((f) => !(JSON.stringify(item_produto_mp).includes(JSON.stringify(f))));

      return desserts_atualizado.length > 0 || includeValues.length > 0
        ? desserts_atualizado
        : this.desserts_esquerda;
    },
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.initialize();
        this.getProdutosCategoria();
      }
    },
    "itens_selecionados.produtos_mp"(valor) {
      this.getPAFromMP();
    },
    "itens_selecionados.produtos_pa"(valor) {
      this.getMPRelacionadaFromPA();
    },
  },
  methods: {
    initialize() {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        CategoriaMateriaPrimaAPI.getMateriaPrima(headers, { filtro_except: true })
          .then((response) => {
            const { token, materia_prima } = response.data;

            localStorage.setItem("token", token);

            this.desserts.produtos_mp = materia_prima;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
    getProdutosCategoria() {
      this.$store.dispatch(
        "loading/addRequisicao",
        getProdutosCategoria(this.categoria.id_categoria)
          .then((dados) => {
            this.itens_selecionados.produtos_mp = dados.mp;
            this.itens_selecionados.produtos_pa = dados.pa;
          })
          .catch(() => this.Helpers.logout())
      );
    },
    getPAFromMP() {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        filtro_except: true,
        materia_prima: this.itens_selecionados.produtos_mp,
      };
      this.$store.dispatch(
        "loading/addRequisicao",
        CategoriaMateriaPrimaAPI.getPAFromMP(headers, params)
          .then((response) => {
            const { token, produtos_acabado } = response.data;

            localStorage.setItem("token", token);

            this.desserts.produtos_pa = produtos_acabado;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
    getMPRelacionadaFromPA() {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        filtro_except: true,
        materia_prima: this.itens_selecionados.produtos_mp,
        produtos_acabado: this.itens_selecionados.produtos_pa,
      };
      this.$store.dispatch(
        "loading/addRequisicao",
        CategoriaMateriaPrimaAPI.getMPRelacionadaFromPA(headers, params)
          .then((response) => {
            const { token, mp_relacionado } = response.data;

            localStorage.setItem("token", token);

            this.desserts.produtos_mp_relacionado = mp_relacionado;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
    save(evento) {
      const params = {
        ...this.itens_selecionados,
        id_categoria: this.categoria.id_categoria,
        nome_categoria: evento.nome_categoria
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        updateRelacionamentosMPPA(params)
          .then(() => this.atualizarTelaInicialCategoria())
          .catch(() => this.Helpers.logout())
      );
    },
    resetValores() {
      this.search = {
        produtos_mp: "",
        produtos_pa: "",
        produtos_mp_relacionado: "",
      }
      this.itens_selecionados = {
        produtos_mp: [],
        produtos_pa: [],
        produtos_mp_relacionado: []
      }
    },
    fecharDialog() {
      this.resetValores();
      this.dialog = false;
    },
    atualizarTelaInicialCategoria() {
      this.$emit("atualizar-tela-inicial-categoria");
      this.fecharDialog();
    },
  },
};
</script>

<style>
</style>
